/* jshint maxcomplexity: 5, maxparams: 3, maxdepth: 2, maxstatements: 10 */
'use strict';
var priceCollection = require('../collections/pricemanager.collection').getInstance();
var Mixin = require('./mixin');

module.exports = new Mixin({
    bindPriceCollection: function() {
        this.listenTo(priceCollection, 'priceCollection.change', Odigeo._.bind(this.trigger, this, 'priceCollection.repaintPrices'));
    },

    getPriceCollectionData: function() {
        return priceCollection.getJSONData();
    },

    getFinalPrice: function() {
        return Odigeo.Utils.formatCurrency(priceCollection.calculateTotalPrice());
    },

    getPricePerPassenger: function() {
        return Odigeo.Utils.formatCurrency(priceCollection.calculatePricePerPassenger());
    },

    getUnformattedTicketPrice: function() {
        return priceCollection.getTotalTicketPrice();
    },

    getTicketPrice: function() {
        return Odigeo.Utils.formatCurrency(this.getUnformattedTicketPrice());
    },

    getTicketPricePerPassenger: function() {
        return Odigeo.Utils.formatCurrency(priceCollection.getTotalTicketPricePerPax());
    },

    getItemByType: function(type) {
        return priceCollection.getPriceBreakdownItemByType(type);
    },

    getPriceBreakdownItemByConceptKey: function(conceptKey) {
        return priceCollection.getPriceBreakdownItemByConceptKey(conceptKey);
    },

    getPriceBreakdownItemByPolicy: function(policy) {
        return priceCollection.getPriceBreakdownItemByPolicy(policy);
    },

    getSHPrice: function() {
        return priceCollection.getSHPrice();
    },

    getPayWithGuaranteeItemInCollection: function() {
        return priceCollection.getPayWithGuaranteeItemInCollection();
    },
});
